import { getConfig } from "../../../../hooks/use-config";
import { uniqueArray } from "../../../../utils/common-utils";
import { getSubmissionData } from "../../../Registration/hooks/use-helpers";
import { getMaterialAssociatedOptions } from "../../../SupplierDetail/supplier-detail-utils";

export const getSupplierFilterDetails = (regularFilters, advanceFilters) => {
  const { required: reqularRequired, fieldData: regularData } =
    getSubmissionData(regularFilters);
  const { required: advanceRequired, fieldData: advanceData } =
    getSubmissionData(advanceFilters);

  return {
    required: { ...reqularRequired, ...advanceRequired },
    fieldData: { ...regularData, ...advanceData },
  };
};

export const getMaterialsByOptions = (
  containerMaterials,
  containerOptions,
  values
) => {
  let fieldMaterials = [];

  if (values.length > 0) {
    const selectedOptions = containerOptions.filter(({ id }) =>
      values.includes(id)
    );

    selectedOptions.forEach((optionItem) => {
      const associatedMaterials = getMaterialAssociatedOptions(
        containerMaterials,
        optionItem.code
      );

      fieldMaterials = [...fieldMaterials, ...associatedMaterials];
    });
  }

  const uniqueMaterials = uniqueArray(fieldMaterials);

  return uniqueMaterials;
};

export const hasAccessoryOptions = (containerOptions, values) => {
  if (!values || !values.length) return false;

  const selectedOptions = containerOptions.filter(
    ({ id, accessory }) => values.includes(id) && accessory
  );

  return selectedOptions.length > 0;
};

export const getDefaultVolume = (paramValues) => {
  const minVolume = paramValues["products.minVolume"];
  const maxVolume = paramValues["products.maxVolume"];

  const minContainerVolume = +getConfig("minContainerVolume");
  const maxContainerVolume = +getConfig("maxContainerVolumeFilter");

  return [minVolume || minContainerVolume, maxVolume || maxContainerVolume];
};
